// src/App.tsx
import React from 'react';
import Home from './pages/Home';
import './App.css';

const App: React.FC = () => (
  <div className="App">
    <Home />
  </div>
);

export default App;
